import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Advertisers from './pages/Advertisers';
import About from './pages/About';
import Contact from './pages/Contact';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';
import './App.css';
import Terms from './pages/Terms';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

function App() {
  // Always use dark mode
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <div className="App dark">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen bg-slate-900">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/advertisers" element={<Advertisers />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/imprint" element={<Imprint />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/agb" element={<Terms />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster
            position="top-right"
            richColors
            closeButton
            toastOptions={{
              className: 'bg-slate-800 text-white',
            }}
          />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
